import React from 'react';
import { WifiOff } from 'lucide-react';

/**
 * Shown in place of the app whenever NetworkProvider reports offline — on first
 * launch (before any API call fires) and any time connectivity drops mid-session.
 * Dismisses itself automatically the moment NetworkProvider sees a reconnect;
 * the button is just a fallback for anyone who doesn't trust that.
 */
const NoInternetScreen = () => (
  <div
    className="min-h-screen flex flex-col items-center justify-center p-6 text-center"
    style={{ background: 'var(--theme-background, #FDFBF7)' }}
    data-testid="no-internet-screen"
  >
    <div className="w-20 h-20 rounded-full flex items-center justify-center mb-6 bg-black/5">
      <WifiOff className="w-10 h-10" style={{ color: 'var(--theme-primary, #2E3B32)' }} />
    </div>
    <h1
      className="text-xl font-bold mb-2"
      style={{ color: 'var(--theme-text-main, #1A1D1A)' }}
    >
      No Internet Connection
    </h1>
    <p
      className="text-sm max-w-xs mb-6"
      style={{ color: 'var(--theme-text-muted, #5C635A)' }}
    >
      Check your connection — we'll reconnect automatically as soon as it's back.
    </p>
    <button
      onClick={() => window.location.reload()}
      className="px-6 py-2.5 rounded-xl text-sm font-semibold text-white"
      style={{ background: 'var(--theme-primary, #2E3B32)' }}
      data-testid="no-internet-retry-btn"
    >
      Try Again
    </button>
  </div>
);

export default NoInternetScreen;
